// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `section {
  font-weight: 100;
  margin: 5px 0 !important;
}
section.rounded {
  display: flex;
  border: 1px solid #dbdcdd;
  border-radius: 6px;
  padding: 0 10px;
  float: left;
  width: 160px !important;
}
section span {
  color: black;
}

span.status {
  margin-top: 12px;
  height: 14px;
  width: 14px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  background-color: white;
}
span.status .status-icon {
  display: block;
  width: 7px;
  height: 7px;
  position: relative;
  color: inherit;
}
span.status.complete {
  border: 2px solid #8cb23f;
}
span.status.complete .status-icon {
  color: #8cb23f;
  width: 7px;
  height: 4px;
  border-left: 2px solid currentColor;
  border-bottom: 2px solid currentColor;
  transform: rotate(-45deg) translateY(-1px);
}
span.status.pending {
  border: 2px solid #f19626;
}
span.status.pending .status-icon {
  color: #f19626;
}
span.status.pending .status-icon::before,
span.status.pending .status-icon::after {
  content: "";
  position: absolute;
  background: currentColor;
  border-radius: 1px;
}
span.status.pending .status-icon::before {
  width: 1.5px;
  height: 3px;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
}
span.status.pending .status-icon::after {
  width: 3px;
  height: 1.5px;
  left: 50%;
  top: 50%;
  transform: translateY(-50%);
}
span.status.danger {
  border: 2px solid #d44242;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
